import { render, staticRenderFns } from "./Datos_en.vue?vue&type=template&id=d6208c60&scoped=true&"
import script from "./Datos_en.vue?vue&type=script&lang=js&"
export * from "./Datos_en.vue?vue&type=script&lang=js&"
import style0 from "./Datos_en.vue?vue&type=style&index=0&id=d6208c60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6208c60",
  null
  
)

export default component.exports